import { deviceIdGet, sessionIdGet, windowIdGet } from '@codestreet/utils'

import { env } from '@/shared/config'

import { AnalyticsService } from './analytics.service'

export const analytics = new AnalyticsService(
  windowIdGet(),
  sessionIdGet(),
  deviceIdGet(),
  env.MODE !== 'production',
)
